import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom'
import { LoginSocialFacebook } from 'reactjs-social-login'
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import jwt_decode from "jwt-decode";

import banner from '../../images/banners/login.jpg'
import BACKEND_URL from '../../api';
import "../../Login.css"
import loading from '../../images/spin.gif'
import FaceRecognitionModal from './FaceRecognitionModal';

export default function Login() {
    const navigate = useNavigate()
    const [loggeduser, setloggeduser] = useState({
        username: "",
        password: ""
    })
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [capturedImage, setCapturedImage] = useState(null)
    const [provider, setProvider] = useState('')
    const [profile, setProfile] = useState()
    const [register, setregister] = useState({
        username: '',
        email: '',
        first_name: '',
        last_name: '',
        phone_number: '',
        password: ''
    })
    const [submitreg, setsubmitreg] = useState(false)
    const [loadingshow, setloadingshow] = useState(false);

    useEffect(() => {
        if (provider != "") {
            console.log("provider------", provider)
            console.log("profile------", profile)
            if (provider == 'google') {
                setregister({
                    ...register, username: profile.given_name, email: profile.email, first_name: profile.given_name,
                    last_name: profile.family_name, password: profile.name
                })
                setsubmitreg(true)
            }

            if (provider == 'facebook') {
                setregister({
                    ...register, username: profile.first_name, email: profile.email, first_name: profile.first_name,
                    last_name: profile.last_name, password: profile.name
                })
                setsubmitreg(true)
            }
        }
    }, [provider])

    useEffect(() => {
        if (register != "" && provider != '') {
            console.log("register-----", register.email)
            if (register.email != "" && register.email !== undefined) {
                console.log(register)

                setloadingshow(true);
                fetch(`${BACKEND_URL}/socialLogin`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(register) // Convert `register` object to JSON string
                })
                    .then((res) => {
                        if (!res.ok) {
                            throw new Error('Network response was not ok ' + res.statusText);
                        }
                        return res.json(); // Parse the JSON from the response
                    })
                    .then((data) => {
                        console.log("sociallogindata---------", data)
                        if (data.code === 0) {
                            // Handle the case where code is 0
                        } else {
                            sessionStorage.setItem('userid', data.userid);
                            navigate('/my-account/my-parcels');
                        }
                    })
                    .catch((err) => console.log(err))
                    .finally(() => {
                        setloadingshow(false)
                    });
            } else {
                alert('unable to access your gmail details')
            }
        }
    }, [submitreg])

    function login() {
        if (loggeduser.username != "" && loggeduser.password != "") {
            fetch(`${BACKEND_URL}/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(loggeduser),
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then((data) => {
                    console.log(data);
                    if (data.status === "1") {
                        sessionStorage.setItem('userid', data.userid);
                        sessionStorage.setItem('corporate_customer', data.corporate_customer);
                        navigate('/my-account/dashboard');
                    } else {
                        alert("Incorrect email or password. Please try again.");
                    }
                })
                .catch((err) => console.log(err));
        } else {
            alert("Enter username and password")
        }
    }

    return (
        <div>
            <Helmet>
                <title>Shypv | Login</title>
            </Helmet>
            <section className="your_business_page fw" style={{ backgroundImage: `url(${banner})`, backgroundAttachment: 'fixed', backgroundSize: 'cover' }}>
                <div className="container"><div className="row">
                    <div className="col-md-12 col-sm-12 your_business text-center">
                        <div className="business_content">

                            <h1 className="mainhead">LOGIN</h1>
                        </div>
                    </div>
                </div>
                </div>
            </section>

            <div className="pages_content">
                <div className="container">
                    <div className="row">
                        <div className="col-md-2"></div>
                        {loadingshow ? (
                            <p style={{ textAlign: "center", marginTop: "1%", paddingBottom: "2%" }}><img src={loading} style={{ width: "2%" }} /></p>
                        ) : <>
                            <div className="col-md-8"
                                style={{
                                    marginTop: "6%", // Existing top margin
                                    marginBottom: "6%", // Existing bottom margin
                                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)", // New shadow effect
                                    borderRadius: "8px", // Optional: add rounded corners
                                    // backgroundColor: "white"
                                }}
                            >
                                <div id="primary" className="content-area" style={{ float: 'left', padding: '10% 5%', width: "100%" }}>
                                    <main id="main" className="site-main" role="main">
                                        <div className='login-form'>
                                            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                                                <div>
                                                    <h4 style={{ fontFamily: "bold" }}>Sign in</h4>
                                                    <hr />
                                                </div>
                                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                                    <p style={{ fontSize: "0.875em" }}>Username <span style={{ color: "red" }}>*</span></p>
                                                    <input type="text" placeholder='username' className="form-control" style={{ borderRadius: "5px", width: "60%", fontSize: "0.875em" }} required onChange={(e) => setloggeduser({ ...loggeduser, username: e.target.value })} />
                                                </div>
                                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                                    <p style={{ fontSize: "0.875em" }}>Password <span style={{ color: "red" }}>*</span></p>
                                                    <input type="password" placeholder='password' className="form-control" style={{ borderRadius: "5px", width: "60%", fontSize: "0.875em" }} required onChange={(e) => setloggeduser({ ...loggeduser, password: e.target.value })} />
                                                </div>
                                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                                    <Link style={{ color: "#3c50e0" }} className="loginaction" to="/reset-password">
                                                        <p style={{ fontSize: "0.875em" }}>
                                                            Forgot Password
                                                        </p>
                                                    </Link>
                                                    <div className="submit-button" style={{ width: "40%", fontSize: "0.875em" }} onClick={login}>
                                                        Login
                                                    </div>
                                                </div>
                                                <div style={{ border: "1px solid #babbbc", padding: "5px 10px", fontSize: "1em", display: "flex", justifyContent: "center" }}>
                                                    Don't have an account?&nbsp;&nbsp;&nbsp; <Link style={{ color: "#3c50e0" }} className='loginaction' to="/register"> Create One!</Link>
                                                </div>
                                            </div>
                                            <div style={{ borderLeft: "1px solid #babbbc", display: "flex" }}></div>
                                            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                                                <div>
                                                    <h4 style={{ fontFamily: "bold" }}>Sign in with</h4>
                                                    <hr />
                                                </div>
                                                <div style={{ display: "flex", flexDirection: "column", gap: "20px", alignItems: "center" }}>
                                                    <LoginSocialFacebook
                                                        appId={659280453604223}

                                                        onResolve={({ provider, data }: IResolveParams) => {
                                                            setProvider(provider)
                                                            setProfile(data)
                                                        }}
                                                        onReject={(err) => {
                                                            console.log(err)
                                                        }}
                                                    >
                                                        <button className="facebook-button">
                                                            <div className="svg-wrapper-1">
                                                                <div className="svg-wrapper">
                                                                    <svg
                                                                        viewBox="0 0 320 512"
                                                                        height="1.2em"
                                                                        fill="currentColor"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
                                                                        ></path>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                            <span>Facebook</span>
                                                        </button>
                                                    </LoginSocialFacebook>

                                                    <GoogleOAuthProvider clientId="552205000057-985jmkkkk1j53bmkn1vq9t8vb1sm8s86.apps.googleusercontent.com" >
                                                        <GoogleLogin
                                                            onSuccess={tokenResponse => {
                                                                setProvider('google')
                                                                setProfile(jwt_decode(tokenResponse.credential))
                                                            }}
                                                            onError={() => {
                                                                console.log('Login Failed')
                                                            }}
                                                            logo_alignment='center'
                                                            text='signin_with'
                                                            shape='circle'

                                                        />
                                                    </GoogleOAuthProvider>

                                                    {/* <button className="facebook-button" onClick={() => setIsModalOpen(true)}>
                                                    <span>Face Recognition</span>
                                                </button> */}
                                                    {capturedImage}
                                                </div>
                                            </div>
                                        </div>
                                    </main>
                                </div>
                            </div>
                            {
                                isModalOpen &&
                                <FaceRecognitionModal
                                    onClose={() => setIsModalOpen(false)}
                                    capturedImage={capturedImage}
                                    setCapturedImage={(value) => setCapturedImage(value)}
                                    mode="login"
                                />
                            }
                        </>}
                    </div>
                </div>
            </div>
        </div>
    )
}
